(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define("react-perfect-scrollbar", ["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["react-perfect-scrollbar"] = factory(require("react"), require("prop-types"));
	else
		root["react-perfect-scrollbar"] = factory(root["React"], root["PropTypes"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition